import apiClient, { IresponseData } from "@/lib/api";

export interface MpPreferenceInput {
  planId: string;
  billingCycle: "MONTHLY" | "YEARLY";
}

export interface MpPreferenceResult {
  preferenceId: string;
  amount: number;
}

export interface MpSubscribeResult {
  preapprovalId: string;
  status: string;
}

export interface MpSubscriptionStatus {
  id: string;
  mpPreapprovalId: string;
  status: "PENDING" | "ACTIVE" | "PAUSED" | "CANCELLED";
  initPoint: string | null;
  mpPayerEmail: string | null;
  createdAt: string;
}

export const billingService = {
  async createMpPreference(
    input: MpPreferenceInput
  ): Promise<IresponseData<MpPreferenceResult>> {
    const response = await apiClient.post<IresponseData<MpPreferenceResult>>(
      "/billing/mp/preference",
      input
    );
    return response.data;
  },

  async cancelMercadoPago(): Promise<IresponseData<{ preapprovalId: string }>> {
    const response = await apiClient.post<
      IresponseData<{ preapprovalId: string }>
    >("/billing/mp/cancel");
    return response.data;
  },

  async getMpStatus(): Promise<IresponseData<MpSubscriptionStatus>> {
    const response = await apiClient.get<IresponseData<MpSubscriptionStatus>>(
      "/billing/mp/status"
    );
    return response.data;
  },
};
